module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "custom-class": "inventory-dialog",
      "visible": _vm.dialogVisible,
      "close-on-click-modal": false,
      "modal-append-to-body": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('el-button', {
          on: {
            "click": function($event) {
              _vm.dialogVisible = false
            }
          }
        }, [_vm._v("关闭")])]
      },
      proxy: true
    }])
  }, [_c('template', {
    slot: "title"
  }, [_c('span', {
    staticClass: "inventory-dialog__title"
  }, [_vm._v("查看库存")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "inventory-body"
  }, [(!_vm.loading && _vm.packageList.length === 0) ? _c('div', {
    staticClass: "inventory-empty"
  }, [_vm._v("\n      暂无套餐数据\n    ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.packageList), function(pkg, idx) {
    return _c('div', {
      key: pkg.packageId != null ? pkg.packageId : idx,
      staticClass: "inv-pkg-card"
    }, [_c('div', {
      staticClass: "inv-info-row"
    }, [_c('span', {
      staticClass: "inv-label"
    }, [_vm._v("套餐名称")]), _vm._v(" "), _c('span', {
      staticClass: "inv-value"
    }, [_vm._v(_vm._s(pkg.packageName))])]), _vm._v(" "), _c('div', {
      staticClass: "inv-info-row"
    }, [_c('span', {
      staticClass: "inv-label"
    }, [_vm._v("限量类型")]), _vm._v(" "), _c('span', {
      staticClass: "inv-value"
    }, [_vm._v(_vm._s(pkg.limitType === 1 ? "套餐限量" : "奖品限量"))])]), _vm._v(" "), _c('div', {
      staticClass: "inv-info-row inv-info-row--section-title"
    }, [_c('span', {
      staticClass: "inv-label"
    }, [_vm._v("关联奖品")])]), _vm._v(" "), (pkg.limitType === 1) ? [_c('el-table', {
      staticClass: "inv-prize-table",
      attrs: {
        "data": pkg.prizeItems || [],
        "border": "",
        "size": "small"
      }
    }, [_c('el-table-column', {
      attrs: {
        "prop": "prizeId",
        "label": "奖品ID",
        "align": "center",
        "width": "100"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "prizeName",
        "label": "奖品名称",
        "align": "center",
        "min-width": "110"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "奖品类型",
        "align": "center",
        "width": "110"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(ref) {
          var row = ref.row;

          return [_vm._v(_vm._s(_vm.getPrizeTypeLabel(row.prizeType)))]
        }
      }], null, true)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "是否活动限定",
        "align": "center",
        "min-width": "120"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(ref) {
          var row = ref.row;

          return [(row.isLimit === 1) ? _c('span', [_vm._v(_vm._s(row.label || "是"))]) : _c('span', [_vm._v("否")])]
        }
      }], null, true)
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "inv-info-row inv-info-row--mt"
    }, [_c('span', {
      staticClass: "inv-label"
    }, [_vm._v("初始套餐库存")]), _vm._v(" "), _c('span', {
      staticClass: "inv-value"
    }, [_vm._v(_vm._s(pkg.isLimit === 1 ? (pkg.limitValue != null ? pkg.limitValue : "–") : "--"))])]), _vm._v(" "), _c('div', {
      staticClass: "inv-info-row"
    }, [_c('span', {
      staticClass: "inv-label"
    }, [_vm._v("实际总库存")]), _vm._v(" "), _c('span', {
      staticClass: "inv-value"
    }, [_vm._v(_vm._s(pkg.isLimit === 1 ? (pkg.totalInventory != null ? pkg.totalInventory : "–") : "--"))])]), _vm._v(" "), _c('div', {
      staticClass: "inv-info-row inv-pkg-quota-row"
    }, [_c('span', {
      staticClass: "inv-label"
    }, [_vm._v("剩余库存")]), _vm._v(" "), (pkg.isLimit !== 1) ? [_c('span', {
      staticClass: "inv-pkg-quota-value"
    }, [_vm._v("--")])] : (_vm.isEditingPackage(pkg)) ? [_c('div', {
      staticClass: "inv-edit-row"
    }, [_c('span', {
      staticClass: "inv-edit-quota"
    }, [_vm._v(_vm._s(pkg.leftQuota != null ? pkg.leftQuota : "–"))]), _vm._v(" "), _c('el-select', {
      staticClass: "inv-edit-select",
      attrs: {
        "size": "mini"
      },
      on: {
        "change": _vm.onPackageActionChange
      },
      model: {
        value: (_vm.editingPackage.action),
        callback: function($$v) {
          _vm.$set(_vm.editingPackage, "action", $$v)
        },
        expression: "editingPackage.action"
      }
    }, [_c('el-option', {
      attrs: {
        "label": "增加",
        "value": "add"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": "减少",
        "value": "sub"
      }
    })], 1), _vm._v(" "), _c('el-input', {
      staticClass: "inv-edit-input",
      attrs: {
        "value": _vm.editingPackage.amount,
        "size": "mini",
        "placeholder": "数量"
      },
      on: {
        "input": _vm.filterPackageAmount
      }
    }), _vm._v(" "), _c('el-button', {
      attrs: {
        "size": "mini",
        "type": "primary",
        "loading": _vm.submitting
      },
      on: {
        "click": function($event) {
          return _vm.confirmAdjustPackage(pkg)
        }
      }
    }, [_vm._v("确定")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "size": "mini"
      },
      on: {
        "click": function($event) {
          _vm.editingPackage = null
        }
      }
    }, [_vm._v("取消")])], 1)] : [_c('span', {
      staticClass: "inv-pkg-quota-value"
    }, [_vm._v(_vm._s(pkg.leftQuota != null ? pkg.leftQuota : "–"))]), _vm._v(" "), _c('el-button', {
      staticClass: "inv-pkg-quota-edit-btn",
      attrs: {
        "size": "mini",
        "type": "text"
      },
      on: {
        "click": function($event) {
          return _vm.startEditPackage(pkg)
        }
      }
    }, [_vm._v("编辑")])]], 2)] : [_c('el-table', {
      staticClass: "inv-prize-table",
      attrs: {
        "data": pkg.prizeItems || [],
        "border": "",
        "size": "small"
      }
    }, [_c('el-table-column', {
      attrs: {
        "prop": "prizeId",
        "label": "奖品ID",
        "align": "center",
        "width": "80"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "prizeName",
        "label": "奖品名称",
        "align": "center",
        "min-width": "90"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "奖品类型",
        "align": "center",
        "width": "90"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(ref) {
          var row = ref.row;

          return [_vm._v(_vm._s(_vm.getPrizeTypeLabel(row.prizeType)))]
        }
      }], null, true)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "初始奖品库存",
        "align": "center",
        "width": "90"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(ref) {
          var row = ref.row;

          return [(row.isLimit != 1) ? _c('span', [_vm._v("不限量")]) : _c('span', [_vm._v(_vm._s(row.quantity != null ? row.quantity : "–"))])]
        }
      }], null, true)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "实际总库存",
        "align": "center",
        "width": "80"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(ref) {
          var row = ref.row;

          return [(row.isLimit != 1) ? _c('span', [_vm._v("–")]) : _c('span', [_vm._v(_vm._s(row.totalInventory != null ? row.totalInventory : "–"))])]
        }
      }], null, true)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "剩余库存",
        "align": "center",
        "min-width": "280"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(ref) {
          var row = ref.row;

          return [(row.isLimit != 1) ? _c('span', [_vm._v("–")]) : (_vm.isEditingPrize(pkg, row)) ? [_c('div', {
            staticClass: "inv-edit-row"
          }, [_c('span', {
            staticClass: "inv-edit-quota"
          }, [_vm._v(_vm._s(row.leftQuota != null ? row.leftQuota : "–"))]), _vm._v(" "), _c('el-select', {
            staticClass: "inv-edit-select",
            attrs: {
              "size": "mini"
            },
            on: {
              "change": _vm.onPrizeActionChange
            },
            model: {
              value: (_vm.editingPrize.action),
              callback: function($$v) {
                _vm.$set(_vm.editingPrize, "action", $$v)
              },
              expression: "editingPrize.action"
            }
          }, [_c('el-option', {
            attrs: {
              "label": "增加",
              "value": "add"
            }
          }), _vm._v(" "), _c('el-option', {
            attrs: {
              "label": "减少",
              "value": "sub"
            }
          })], 1), _vm._v(" "), _c('el-input', {
            staticClass: "inv-edit-input",
            attrs: {
              "value": _vm.editingPrize.amount,
              "size": "mini",
              "placeholder": "数量"
            },
            on: {
              "input": _vm.filterAmount
            }
          }), _vm._v(" "), _c('el-button', {
            attrs: {
              "size": "mini",
              "type": "primary",
              "loading": _vm.submitting
            },
            on: {
              "click": function($event) {
                return _vm.confirmAdjust(pkg)
              }
            }
          }, [_vm._v("确定")]), _vm._v(" "), _c('el-button', {
            attrs: {
              "size": "mini"
            },
            on: {
              "click": function($event) {
                _vm.editingPrize = null
              }
            }
          }, [_vm._v("取消")])], 1)] : [_c('span', [_vm._v(_vm._s(row.leftQuota != null ? row.leftQuota : "–"))]), _vm._v(" "), _c('el-button', {
            staticClass: "inv-edit-btn",
            attrs: {
              "size": "mini",
              "type": "text"
            },
            on: {
              "click": function($event) {
                return _vm.startEditPrize(pkg, row)
              }
            }
          }, [_vm._v("编辑")])]]
        }
      }], null, true)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "是否活动限定",
        "align": "center",
        "min-width": "90"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(ref) {
          var row = ref.row;

          return [(row.isLimit === 1) ? _c('span', [_vm._v(_vm._s(row.label || "是"))]) : _c('span', [_vm._v("否")])]
        }
      }], null, true)
    })], 1)]], 2)
  })], 2)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-16800532!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/yunying/onlineMatch/InventoryDialog.vue
// module id = 951
// module chunks = 0